/*! bluetti v2.0.0 | (c) 2022 Bluettipower | MIT License | https://gitee.com/bluetti/shopify-gulp.git */
(()=>{
    class e extends HTMLElement {
        constructor() {
            super(),
            this.updateSections(),
            this.querySelectorAll("[data-filter-tab]").forEach(e=>{
                e.addEventListener("click", e=>{
                    e.target.closest("ul").querySelectorAll("li").forEach(e=>e.classList.remove("tm-active")),
                    e.target.closest("li").classList.add("tm-active"),
                    this.updateSections(e.target.dataset.filterTab)
                }
                , !1)
            }
            )
        }
        updateSections(e) {
            e = e || "group_1";
            document.querySelectorAll("[data-filter]").forEach(e=>e.classList.add("uk-hidden")),
            document.querySelectorAll(`[data-filter="${e}"]`).forEach(e=>e.classList.remove("uk-hidden"))
        }
    }
    customElements.define("tab-filter", e);
    class t extends HTMLElement {
        constructor() {
            super(),
            this.updateSections(),
            this.querySelectorAll("[data-filter-tab]").forEach(e=>{
                e.addEventListener("click", e=>{
                    e.target.closest("ul").querySelectorAll("li").forEach(e=>e.classList.remove("tm-active")),
                    e.target.closest("li").classList.add("tm-active"),
                    this.updateSections(e.target.dataset.filterTabPartition, e.target.dataset.filterTab)
                }
                , !1)
            }
            )
        }
        updateSections(i, s) {
            document.querySelectorAll("[data-filter-partition]").forEach(e=>{
                var t = s || "group_1";
                document.querySelectorAll("[data-filter]").forEach(e=>{
                    i === e.dataset.filterPartition && e.classList.add("uk-hidden")
                }
                ),
                document.querySelectorAll(`[data-filter="${t}"]`).forEach(e=>{
                    i === e.dataset.filterPartition && e.classList.remove("uk-hidden")
                }
                )
            }
            )
        }
    }
    customElements.define("tab-filter1", t);
    class i extends HTMLElement {
        constructor() {
            super(),
            document.addEventListener("scroll", ()=>{
                this.classList.toggle("uk-hidden", document.documentElement.scrollTop <= 600)
            }
            )
        }
    }
    if (!customElements.get('back-to-top')) {
        customElements.define("back-to-top", i);
    }
    class s extends HTMLElement {
        constructor() {
            super(),
            window.Shopify.loadFeatures([{
                name: "consent-tracking-api",
                version: "0.1"
            }], e=>{
                if (e)
                    throw e;
                setTimeout(()=>{
                    this.initCookieBanner()
                }
                , 3e3)
            }
            ),
            this.addEventListener("hide", ()=>{
                this.handleAccept(),
                console.log("hide")
            }
            )
        }
        toggleCookie(e=!0) {
            this.classList.toggle("active", e)
        }
        handleAccept(e) {
            const t = window.Shopify["customerPrivacy"];
            t.setTrackingConsent(!0, this.toggleCookie.bind(this, !1)),
            document.addEventListener("trackingConsentAccepted", ()=>{
                console.log("trackingConsentAccepted event fired")
            }
            )
        }
        handleDecline() {
            const e = window.Shopify["customerPrivacy"];
            e.setTrackingConsent(!1, this.toggleCookie.bind(this, !1))
        }
        initCookieBanner() {
            const e = window.Shopify["customerPrivacy"]
              , t = e.userCanBeTracked()
              , i = e.getTrackingConsent();
            t && "no_interaction" === i ? this.toggleCookie() : this.remove()
        }
    }
    customElements.define("cookie-banner", s);
    class r extends HTMLElement {
        constructor() {
            super(),
            this.time = this.dataset.time,
            this.timer = null,
            this.timeText = this.querySelector("[data-time]"),
            this.redirectUrl = this.querySelector("[href]").getAttribute("href"),
            this.init()
        }
        init() {
            clearInterval(this.timer),
            this.timeText.innerText = this.time + "s",
            this.timer = setInterval(()=>{
                this.timeText.innerText = --this.time + "s",
                this.time <= 0 && (clearInterval(this.timer),
                this.redirect(this.redirectUrl))
            }
            , 1e3)
        }
        redirect(e="/") {
            Shopify.designMode || (window.location.href = e)
        }
    }
    customElements.define("section-redirect", r);
    class o extends HTMLElement {
        constructor() {
            super();
            let e = null;
            const t = this.dataset["time"]
              , i = UIkit.countdown(this, {
                date: t
            });
            this.classList.toggle("uk-hidden", !i.timer),
            e = setInterval(()=>{
                Date.parse(t) - (new Date).getTime() < 0 && (this.remove(),window.dispatchEvent(new Event('countdown-end')),
                clearInterval(e))
            }
            , 100)
        }
    }
    customElements.define("countdown-time", o)
}
)();